import {get} from 'lodash';

export default (state = {}, {email}: {email?: string} = {}) => {
  return {
    ...state,
    credentials: {
      ...get(state, 'credentials', {}),
      email,
    },
  };
};
